<template>
    <v-dialog max-width="50%" v-model="dialog">
        <v-card class="ma-0 pa-0">
            <v-card-actions class="ma-0 pa-0">
                <v-spacer></v-spacer>
                <v-btn icon class="ma-1" color="red" @click="onClose">
                    <v-icon>mdi-close</v-icon>
                </v-btn>
            </v-card-actions>
            <v-card-actions class="py-0">

                <v-slide-group

                        active-class="success"
                        show-arrows>

                    <v-slide-item v-for="character in characters" :key="character.code">

                        <v-card v-if="character.code != 0"
                                :color="model == character.code ? 'green' : 'lighten-1'"
                                class="ma-1"
                                elevation="0"
                                height="150"
                                width="150"
                                outlined
                                @click="onSelect(character.code)">

                            <v-progress-circular v-if="getUrl(character.key) == undefined"
                                                 style="margin-top: 60px; margin-left: 55px"
                                                 indeterminate
                                                 color="orange"
                            ></v-progress-circular>

                            <v-img v-else max-width="150"
                                   :src="getUrl(character.key)">
                            </v-img>

                        </v-card>

                    </v-slide-item>
                </v-slide-group>

            </v-card-actions>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn class="ma-2"
                       color="primary"
                       @click="onPressSave">Set
                </v-btn>
                <v-spacer></v-spacer>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import {HeroKind} from "@/modules/redactor/models/hero/HeroKind";
import firebase from "firebase";

export default {
    name: "utils-popup-select-character",
    props: {},
    components: {},
    data: () => ({
        dialog: false,
        onComplete:null,
        model: null,
        imagesUrls: [],
    }),
    computed: {
        characters(){
            console.log("get characters");
            return HeroKind.getValues().sort((a, b) => a.code > b.code ? 1 : -1);
        },
    },
    methods: {
        onSelect(key) {
            this.model = key
        },
        show(oldKey, onComplete) {
            this.model = oldKey
            this.dialog = true
            this.onComplete = onComplete
            for (var i in this.characters){
                this.getImage(this.characters[i].key);
            } 
        },
        hide() {
            this.dialog = false
        },
        onClose() {
            this.hide()
        },
        onPressSave() {
            if (this.model == null || this.model == undefined){
                return;
            }
            this.dialog = false
            this.onComplete(this.model)
        },
        getUrl(key){
            return this.imagesUrls[key]
        },
        getImage(key){
            firebase.storage()
                .ref('assets/ch/'+key+'_0.png')
                .getDownloadURL().then((url) => {
                this.imagesUrls[key] = url;
                this.$forceUpdate();
            }).catch(() => {
                this.imagesUrls[key] = require("@/modules/muiutils/resources/no-image-icon.png");
                this.$forceUpdate();
            });
        },
    },
}
</script>

<style scoped>

</style>